import { CSSProperties } from 'react';
import { Box, Typography } from '@material-ui/core';
import { styled } from '@material-ui/core/styles';

export const drawerPaperStyles: CSSProperties = {
  borderRadius: '16px 0 0 16px',
  borderColor: '#E1E4E8',
  width: '816px',
  padding: '40px',
};

export const DrawerHeader = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  width: '100%',
});

export const DrawerHeaderSide = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  minWidth: 80,
});

export const DrawerHeaderCenter = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flex: 1,
});

export const RequiredFieldNote = styled(Typography)({
  fontStyle: 'italic',
  display: 'block',
  marginLeft: 'auto',
});
